import React from 'react';
import { Search } from 'lucide-react';
export function SearchBar() {
  return <div className="flex-1 max-w-[800px] px-4" data-id="element-310">
      <div className="relative group" data-id="element-311">
        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-312">
          <Search className="h-5 w-5 text-text-secondary group-focus-within:text-text-primary transition-colors" data-id="element-313" />
        </div>
        <input type="text" placeholder="Search" className="block w-full pl-12 pr-4 py-3 bg-pinterest-gray hover:bg-[#e1e1e1] focus:bg-white border-transparent focus:border-blue-400 focus:ring-4 focus:ring-blue-100 rounded-pill text-text-primary placeholder-text-secondary transition-all duration-200 outline-none text-base" data-id="element-314" />
      </div>
    </div>;
}